import { FormStore, GlobalStore } from '@roc/feature-app-core';

const form = {
  fields: {
    annualTaxAmount: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Annual Tax Amount',
    },
    propertyId: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Property',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class TaxFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
  }
}
